export default {
	"foresite": {
		"addSize": "添加站点"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/foresite/foresite.js